import { Controller } from '@hotwired/stimulus';

// FIXME: スコープ外の要素にアクセスしているので Outlet の利用を検討
export default class extends Controller {
  connect() {
    $(this.element).on('ajax:success', (_xhr, data, _status) => {
      const height =
        (window.innerHeight || document.documentElement.clientHeight) * 0.75;
      $('#previewModal').html(data).modal();
      $('#previewModal').find('.outer .inner').css({ height });
    });

    $(this.element).on('ajax:error', () => {
      alertify.error('エラー');
      $('#previewModal').modal('hide');
    });
  }
}
